__turbopack_context__.v({
  "container": "kWV6OG_container",
  "footerActions": "kWV6OG_footerActions",
});
